/**
 * src/components/Financial/Modules/RetrogradeModule.jsx
 * 【完全修正版：ダークモード対応・デザイン統一】
 */
import React from "react";
import { ArrowLeftRight } from "lucide-react";
import { PLANET_SYMBOLS, PLANET_COLORS } from "../../../utils/constants.js";

/**
 * 惑星逆行ゾーン 描画レイヤー
 */
export const RetrogradeLayer = function (props) {
  var retrogrades = props.retrogrades || {};
  var coords = props.coords; // { getX, pad, iH, candleW }
  var displayRange = props.displayRange; // { start, count }
  var planetColors = props.planetColors || PLANET_COLORS;
  var isDarkMode = props.isDarkMode; // ダークモード判定

  // 必須の座標計算オブジェクトがない場合は描画しない
  if (!coords || !displayRange || typeof coords.getX !== "function")
    return null;

  return (
    <g className="retrograde-zones-layer">
      {Object.entries(retrogrades).map(function (entry) {
        var p = entry[0];
        var idxs = entry[1];
        if (!Array.isArray(idxs)) return null;

        var pColor = planetColors[p] || "#64748b";

        return idxs.map(function (i) {
          // チャートの表示範囲外のインデックスは描画をスキップ
          if (
            i < displayRange.start ||
            i >= displayRange.start + displayRange.count
          )
            return null;

          // チャートのX座標を算出
          var cW = coords.candleW || 5;
          var xPos = coords.getX(i - displayRange.start) - cW / 2;

          return (
            <rect
              key={"ret-" + p + "-" + i}
              x={xPos}
              y={coords.pad.t || 0}
              width={cW}
              height={coords.iH || 0}
              fill={pColor}
              // ダークモード時は不透明度をわずかに下げて背景に馴染ませる
              opacity={isDarkMode ? "0.12" : "0.15"}
              pointerEvents="none"
            />
          );
        });
      })}
    </g>
  );
};

/**
 * 惑星逆行ゾーン 設定UI
 */
export const RetrogradeSettingsUI = function (props) {
  var selectedPlanets = props.selectedPlanets;
  var setSelectedPlanets = props.setSelectedPlanets;
  var isDarkMode = props.isDarkMode;
  var planetColors = props.planetColors || PLANET_COLORS;

  // 主要惑星のみをリストアップ
  var planets = [
    "Mercury",
    "Venus",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Pluto",
  ];

  // テーマ定義の統一
  var theme = {
    cardBg: isDarkMode ? "#1c1f26" : "#f8fafc",
    border: isDarkMode ? "#2d313d" : "#e2e8f0",
    text: isDarkMode ? "#ffffff" : "#1e293b",
    subText: isDarkMode ? "rgba(255, 255, 255, 0.4)" : "#64748b",
  };

  /**
   * 天体選択ボタンの共通スタイル
   */
  var plBtnSt = function (p, active) {
    var pColor = planetColors[p] || "#6366f1";
    return {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: "600",
      cursor: "pointer",
      background: active
        ? isDarkMode
          ? "#374151"
          : "#ffffff"
        : isDarkMode
          ? "#2d2c33" // f98.jpg の基準に合わせた非アクティブ背景
          : "#f1f5f9",
      border:
        "1.5px solid " +
        (active ? pColor : isDarkMode ? "rgba(255,255,255,0.1)" : "#e2e8f0"),
      color: active
        ? isDarkMode
          ? "#ffffff"
          : pColor
        : isDarkMode
          ? "#cccccc"
          : "#64748b",
      transition: "all 0.2s ease",
    };
  };

  var togglePlanet = function (p) {
    var next = new Set(selectedPlanets);
    if (next.has(p)) next.delete(p);
    else next.add(p);
    setSelectedPlanets(next);
  };

  return (
    <div
      style={{
        background: theme.cardBg,
        padding: "20px",
        borderRadius: "12px",
        border: "1px solid " + theme.border,
        color: theme.text,
      }}
    >
      <div
        style={{
          fontSize: "15px",
          fontWeight: "bold",
          color: theme.text,
          marginBottom: "12px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <ArrowLeftRight size={18} color={isDarkMode ? "#ffffff" : "#2c2d96"} />
        <span>惑星逆行ゾーン</span>
      </div>

      <div
        style={{ fontSize: "11px", color: theme.subText, marginBottom: "12px" }}
      >
        逆行期間を背景色で表示する天体を選択してください。
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {planets.map(function (p) {
          var active =
            selectedPlanets && selectedPlanets.has
              ? selectedPlanets.has(p)
              : false;
          return (
            <button
              key={p}
              onClick={function () {
                togglePlanet(p);
              }}
              style={plBtnSt(p, active)}
            >
              <span style={{ fontSize: "14px" }}>{PLANET_SYMBOLS[p]}</span>
              <span>{p}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
